import { SET_FAVOURITE_ORDER, SET_FAVOURITE_ORDER_SUCCESS, SET_FAVOURITE_ORDER_FAILURE, DELETE_FAVOURITE_ORDER, DELETE_FAVOURITE_ORDER_SUCCESS, DELETE_FAVOURITE_ORDER_FAILURE, GET_ORDER_HISTORY, GET_ORDER_HISTORY_SUCCESS, GET_ORDER_HISTORY_FAILURE, RESET_ORDER_HISTORY, GET_ACTIVE_ORDER_HISTORY, GET_ACTIVE_ORDER_HISTORY_SUCCESS, GET_ACTIVE_ORDER_HISTORY_FAILURE, RESET_ACTIVE_ORDER_HISTORY, HIDE_OCCASION_TOAST, } from '../../constants';
import Strings from '../../constants/Strings';
const initialState = {
    addFavouriteOrderSuccess: false,
    addFavouriteOrderLoading: false,
    addFavouriteOrderError: false,
    deleteFavouriteOrderSuccess: false,
    deleteFavouriteOrderLoading: false,
    deleteFavouriteOrderError: false,
    orderHistory: [],
    orderHistoryError: false,
    orderHistoryLoading: false,
    activeOrderHistory: [],
    activeOrderHistoryError: false,
    activeOrderHistoryLoading: false,
};
const OrderHistoryReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case SET_FAVOURITE_ORDER:
            return {
                ...state,
                addFavouriteOrderLoading: true,
                addFavouriteOrderSuccess: false,
            };
        case SET_FAVOURITE_ORDER_SUCCESS:
            return {
                ...state,
                addFavouriteOrderLoading: false,
                addFavouriteOrderSuccess: true,
            };
        case SET_FAVOURITE_ORDER_FAILURE:
            return {
                ...state,
                addFavouriteOrderLoading: false,
                addFavouriteOrderError: true,
            };
        case HIDE_OCCASION_TOAST:
            return {
                ...state,
                addFavouriteOrderSuccess: false,
            };
        case DELETE_FAVOURITE_ORDER:
            return {
                ...state,
                deleteFavouriteOrderLoading: true,
                deleteFavouriteOrderSuccess: false,
            };
        case DELETE_FAVOURITE_ORDER_SUCCESS:
            return {
                ...state,
                deleteFavouriteOrderLoading: false,
                deleteFavouriteOrderSuccess: true,
            };
        case DELETE_FAVOURITE_ORDER_FAILURE:
            return {
                ...state,
                deleteFavouriteOrderLoading: false,
                deleteFavouriteOrderError: true,
            };
        case GET_ORDER_HISTORY:
            return {
                ...state,
                orderHistoryLoading: true,
                orderHistory: [],
                orderHistoryError: false,
            };
        case GET_ORDER_HISTORY_SUCCESS: {
            let temp = action.response;
            let orderHistoryArray = temp.filter(function (e) {
                return e.status !== Strings.posFailed && e.status !== Strings.paymentFailed;
            });
            return {
                ...state,
                orderHistoryLoading: false,
                orderHistory: orderHistoryArray,
                orderHistoryError: false,
            };
        }
        case GET_ORDER_HISTORY_FAILURE:
            return {
                ...state,
                orderHistoryLoading: false,
                orderHistory: [],
                orderHistoryError: true,
            };
        case RESET_ORDER_HISTORY:
            return {
                ...state,
                addFavouriteOrderSuccess: false,
                addFavouriteOrderLoading: false,
                addFavouriteOrderError: false,
                deleteFavouriteOrderSuccess: false,
                deleteFavouriteOrderLoading: false,
                deleteFavouriteOrderError: false,
                orderHistory: [],
                orderHistoryError: false,
                orderHistoryLoading: false,
                activeOrderHistoryError: false,
                activeOrderHistoryLoading: false,
            };
        case GET_ACTIVE_ORDER_HISTORY:
            return {
                ...state,
                activeOrderHistoryLoading: true,
                activeOrderHistory: [],
                activeOrderHistoryError: false,
            };
        case GET_ACTIVE_ORDER_HISTORY_SUCCESS:
            return {
                ...state,
                activeOrderHistoryLoading: false,
                activeOrderHistory: action.response,
                activeOrderHistoryError: false,
            };
        case GET_ACTIVE_ORDER_HISTORY_FAILURE:
            return {
                ...state,
                activeOrderHistoryLoading: false,
                activeOrderHistory: [],
                activeOrderHistoryError: true,
            };
        case RESET_ACTIVE_ORDER_HISTORY:
            return {
                ...state,
                addFavouriteOrderSuccess: false,
                addFavouriteOrderLoading: false,
                addFavouriteOrderError: false,
                deleteFavouriteOrderSuccess: false,
                deleteFavouriteOrderLoading: false,
                deleteFavouriteOrderError: false,
                orderHistoryError: false,
                orderHistoryLoading: false,
                activeOrderHistory: [],
                activeOrderHistoryError: false,
                activeOrderHistoryLoading: false,
            };
        default:
            return state;
    }
};
export default OrderHistoryReducer;
